import React, { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import HoneycombLogo from '../components/HoneycombLogo';
import './LoginPage.css';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, currentUser, isAdmin, loading: authLoading } = useAuth();
    const navigate = useNavigate();

    // Already logged in → send straight to dashboard
    if (!authLoading && currentUser && isAdmin) {
        return <Navigate to="/" replace />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            return setError('Please fill in all fields');
        }

        try {
            setError('');
            setLoading(true);
            await login(email, password);
            navigate('/');
        } catch (error) {
            console.error('Login error:', error);
            if (error.message.includes('Unauthorized')) {
                setError('Access denied. Admin credentials required.');
            } else {
                setError('Failed to login. Check your credentials.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <HoneycombLogo size={60} />
                    <h1>Admin Login</h1>
                    <p>Access the admin portal</p>
                </div>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@skillhive.com"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-full"
                        disabled={loading}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                <div className="auth-footer">
                    <p>Contact system administrator for access</p>
                    <p style={{ marginTop: '10px' }}>
                        <Link to="/forgot-password" style={{ color: '#facc15', fontWeight: 600, textDecoration: 'none', fontSize: '14px' }}>
                            Forgot password?
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
